export default __webpack_public_path__ + "8bce00b9320bf6d28eb16e1dd2ebbb55.png";